import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import HeaderDashboard from "../../components/HeaderDashboard/HeaderDashboard";
import { Menu } from "../../components/menu/Menu";
import "./Dashboard.css";
import userImg from "../../assets/user-d.png";

export const Dashboard = () => {
  // Estado para menú y usuario
  const [visible, setVisible] = useState(true);
  const [windowsMinimize, setWindowsMinimize] = useState(false);

  // 🔹 Datos quemados del usuario
  const userData = {
    name: "Pablo Doe",
    role: "Inversionista",
    image: userImg,
  };

  // 🔹 Responsive sidebar
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 968) {
        setVisible(true);
        setWindowsMinimize(false);
      } else {
        setVisible(false);
        setWindowsMinimize(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hideMenu = () => setVisible(!visible);
  const hideFloatMenu = () => setVisible(false);

  return (
    <div className="dashboard-container">
      <div className="segments">
        {/* Sidebar */}
        <div className="sidebar">
          <div id="menu-container" className={`menu-container ${visible ? "show" : "hide"}`}>
            <Menu
              actions={{ hideFloatMenu, windowsMinimize }}
              userData={userData} // pasamos la data quemada
            />
          </div>
        </div>

        {/* Contenido principal */}
        <div className="segment-container">
          <div className="Header-dashboard-container">
            <HeaderDashboard handlerClick={{ hideMenu }} />
          </div>
          <div className="container-outlet">
            <div className="padding-box">
              <Outlet context={[userData]} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
